export const WORDINGS = {
    EXCLUSIVE_CASHBACK_DEALS: 'Exclusive cashback deals',
    LEARN_MORE: 'Learn more',
    WHAT_IS_THIS: 'What is this?'
};
